import {
    SET_LAST_LOCATION,
    SIDER_COLLAPSED_EXPAND,
    LOGINBYOAUTH,
    SAVED_REQUEST,
} from '../actions/global';

export const initialState = {
    isFetching: true,
    data: null
};

export const global = (state = {}, action) => {
        switch (action.type) {
            case SIDER_COLLAPSED_EXPAND:
                return {...state, siderCollapsed: action.collapsed};
            case SET_LAST_LOCATION:

                //记录上一个页面TablePage中Table滚动条上下滚动位置
                var tempTableScrollTop = {};
                if (state.lastLocation && state.lastLocation.action != "PUSH") {
                    tempTableScrollTop[state.lastLocation.pathname] = action.tableScrollTop;
                }
                const newTableScrollTop = Object.assign({}, state.tableScrollTop, tempTableScrollTop);

                console.log("SET_LAST_LOCATION", {...state, lastLocation: action.location, tableScrollTop: newTableScrollTop});

                return {...state, lastLocation: action.location, tableScrollTop: newTableScrollTop}
            case SAVED_REQUEST:
                return {...state, savedRequest: action.pathname};
            default:
                return {...state};
        }
    }

export const loginByOauth = (state = initialState, action) => {
    switch (action.type) {
        case `${LOGINBYOAUTH}_PENDING`:
            return Object.assign({}, initialState);
        case `${LOGINBYOAUTH}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/global.js